import apiFetch from '../apiFetch'

export default function (token, conditionDocumental) {
  return apiFetch({ endPoint: 'conditionDocumental', method: 'POST', body: conditionDocumental, token: token })
}
